import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLeague } from '../../../../../models/users/user-league.model';
import { UserLeaguesResultsResponse } from '../../../../../models/users/responses/api-users-leagues-results-response.model';
import { ApiUsersService } from '../../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { DateService } from '../../../../../services/date.service';

@Component({
  selector: 'app-user-leagues-tab',
  templateUrl: './user-leagues-tab.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class UserLeaguesTabComponent {

  @Input() userId: number = 0;

  isLoading: boolean = false;

  currentTier: number = 0;
  leagues: UserLeague[] = [];
  resultsPerPage: number = 25;
  pageNumber: number = 1;
  totalResults: number = 0;

  get totalPages(): number {
    return Math.ceil(this.totalResults / this.resultsPerPage);
  }

  getPageNumbers(): (number | null)[] {
    const total = this.totalPages;
    const current = this.pageNumber;

    const visibleSet = new Set<number>();
    for (let i = 1; i <= Math.min(2, total); i++) visibleSet.add(i);
    for (let i = Math.max(total - 1, 1); i <= total; i++) visibleSet.add(i);
    for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) visibleSet.add(i);

    const sorted = Array.from(visibleSet).sort((a, b) => a - b);

    const result: (number | null)[] = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push(null);
      result.push(sorted[i]);
    }

    return result;
  }

  goToPage(page: number): void {
    this.pageNumber = page;
    this.refreshLeaguesList();
  }

  constructor(public dateService: DateService, private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  load(): void {
    this.pageNumber = 1;
    this.refreshLeaguesList();
  }

  onClickPaginationPrevious(): void {
    this.pageNumber--;
    this.refreshLeaguesList();
  }

  onClickPaginationNext(): void {
    this.pageNumber++;
    this.refreshLeaguesList();
  }

  private refreshLeaguesList(): void {
    this.isLoading = true;

    this.apiUsersService.getUserLeagues(this.userId, this.pageNumber, this.resultsPerPage).then(
      (response: UserLeaguesResultsResponse) => {
        this.isLoading = false;
        this.currentTier = response.currentTier;
        this.leagues = response.results;
        this.totalResults = response.resultsTotal;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading leagues (' + error + ')');
      }
    );
  }
}
